import(/* webpackMode: "eager" */ "/codebuild/output/src3323133620/src/portfolio/src/app/page.js");
